import React, { } from "react";
import { Tag } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import Container from "../../General/Container/Container";
import MinifiedDetails from "../../Minified/MinifiedDetails";
import { formatNumber } from "../../../utils/MainHelper";

function MinifiedInsightsTitle({ data }) {
    return <Container className="dcol gap-1 align-start">
        <span className="minified-insights-title">{data.name}</span>
        <MinifiedDetails className="dwrap align-start gap-1 align-start" itemId={data.itemId} data={data} showInfo={false}>
            <Container className="drow align-start">
                <Tag className="minified-details-tag label"><TeamOutlined />Size:</Tag>
                <Tag className={"minified-details-tag" + data.classType}>{formatNumber(data.targetSize)}</Tag>
            </Container>
        </MinifiedDetails>
        <span className="minified-insights-subtitle with-bottom-borderleft" style={{ width: "30%" }}></span>
    </Container>
}
export default MinifiedInsightsTitle;
